import { useNavigate } from "react-router-dom";

import CitationsPanel from "../../../../../components/citations/CitationsPanel";
import useVoiceCitations from "../../../../../hooks/useVoiceCitations";

export default function GRBASPracticeSurface({
  step,
  backPath,
  stimulusSelectionControl = null,
  stimulusContent,
  bodyContent,
  isCompleted = false,
}) {
  const navigate = useNavigate();
  const apiUrl =
    process.env.REACT_APP_API_URL ||
    "http://localhost:5001/api";
  const { voiceDatabase, voiceCollection } =
    useVoiceCitations(
      apiUrl,
      "67b7575a6c7397bd463488d9",
      "6821a3cb6dbf21c7d84eb717"
    );

  return (
    <div className="app-module">
      <div style={{ marginBottom: 16 }}>
        <button
          type="button"
          className="app-btn app-btn-secondary"
          onClick={() => navigate(backPath || "/app/catalog")}
        >
          ⬅ Back to catalog
        </button>
      </div>

      <div style={{ marginBottom: 24 }}>
        <h1 style={{ marginBottom: 8 }}>
          {step?.title || "GRBAS practice"}
        </h1>
        <p style={{ opacity: 0.8 }}>
          {step?.instructions}
        </p>
      </div>

      {isCompleted ? (
        <div style={{ marginTop: 24 }}>
          <h3>Practice complete</h3>
        </div>
      ) : (
        <>
          <div className="app-module-section">
            <div className="app-module-audio-container">
              <h2>Sample</h2>
              {stimulusSelectionControl}
              {stimulusContent}
            </div>
          </div>

          {bodyContent}
        </>
      )}

      <CitationsPanel
        toolName="GRBAS"
        voiceDatabase={voiceDatabase}
        voiceCollection={voiceCollection}
      />
    </div>
  );
}
